import React from 'react';
import './Button.scss';

function Button(props) {
    return <button type={props.type} className={`btn ${props.btnClass}`}>{props.value}</button>
}

export default Button;